import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin,{position: 'middle'})
import router from '@/router'
import utils from '@/utils/util'

let temConfig = null ;

axios.defaults.withCredentials = true

axios.interceptors.request.use(
config => {
if(config.method === "post" && config.headers['Content-Type'] != 'multipart/form-data' )  {
config.data = qs.stringify(config.data,{arrayFormat: 'brackets'})
console.log(config.data)
}
return config;
}
)

axios.interceptors.response.use(
res => {
if(parseInt(res.data.code) == 1){
Vue.$vux.toast.text(res.data.msg,'middle')
}
res.data.code = parseInt(res.data.code)
return res.data
},
error => {
let errMsg = '网路错误'
switch(error.response.status){
case 400:
errMsg = '网路错误';
Vue.$vux.toast.show({
text: errMsg,
type:'cancel'
})
break;
case 401:
errMsg = '未登陆';
sessionStorage.setItem('url',window.location.href.split('#')[1]);
if(process.env.NODE_ENV === 'development'){

}else{
if(utils.judgeBrowser() == 1){
router.replace({name:'Author'});
}else{
router.replace({name:'Login'});
}
}
break;
case 403:
errMsg = '拒绝访问';
Vue.$vux.toast.show({
text: errMsg,
type:'cancel'
})
break;
case 404:
errMsg = '请求地址未找到';
Vue.$vux.toast.show({
text: errMsg,
type:'cancel'
})
break;
case 408:
errMsg = '请求超时';
Vue.$vux.toast.show({
text: errMsg,
type:'cancel'
})
break;
case 500:
errMsg = '服务器内部错误';
Vue.$vux.toast.show({
text: errMsg,
type:'cancel'
})
break;
case 501:
errMsg = '服务未实现';
Vue.$vux.toast.show({
text: errMsg,
type:'cancel'
})
break
case 502:
errMsg = '网关错误';
Vue.$vux.toast.show({
text: errMsg,
type:'cancel'
})
break
case 503:
errMsg = '服务不可用';
Vue.$vux.toast.show({
text: errMsg,
type:'cancel'
})
break
case 504:
errMsg = '网关超时';
Vue.$vux.toast.show({
text: errMsg,
type:'cancel'
})
break
case 505:
errMsg = 'HTTP版本不受支持';
Vue.$vux.toast.show({
text: errMsg,
type:'cancel'
})
break
default:
Vue.$vux.toast.show({
text: errMsg,
type:'cancel'
});
break
}
return Promise.reject(error)
}
)
export default axios;


// WEBPACK FOOTER //
// ./src/axios/index.js